import './FAQ.scss';

import { FaqAccordion } from '@components/FaqAccordion/FaqAccordion';
import { BridgeBioMaterialCode } from '@components/marketing/BridgeBioMaterialCode/BridgeBioMaterialCode';
import { BRIDGE_BIO_CAMPAIGN_CODE } from '@constants/bridgeBio';
import { useOrderContext } from '@pages/order/hooks/useOrderContext';

export const FAQ = () => {
  const { partnerConfig } = useOrderContext();

  if (!partnerConfig) return null;

  const isBridgeBio = partnerConfig.campaignCode === BRIDGE_BIO_CAMPAIGN_CODE;

  return (
    <section className='faq'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <h2>Frequently Asked Questions</h2>
            <FaqAccordion items={partnerConfig.faqs ?? []} />
            {isBridgeBio && (
              <div className='faq__references'>
                <h3 className='faq__references-heading'>REFERENCES</h3>
                <ol>
                  <li>Clarke et al. 2016. DOI: 10.1210/jc.2015-3908</li>
                  <li>Roszko et al. 2022 DOI: 10.1002/jbmr.4659</li>
                </ol>
                <BridgeBioMaterialCode />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
